import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-13791a82")

_pushScopeId("data-v-13791a82")
const _hoisted_1 = {
  key: 1,
  class: "p-fluid p-m-5"
}
const _hoisted_2 = { class: "p-field" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = {
  for: "parameter",
  class: "kn-material-input-label"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "p-field" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "parameterUrlName",
  class: "kn-material-input-label"
}
const _hoisted_11 = { class: "p-field p-mt-2" }
const _hoisted_12 = /*#__PURE__*/_createVNode("i", { class: "fa fa-list p-mr-2" }, null, -1)
const _hoisted_13 = {
  for: "driver-multivalue ",
  class: "kn-material-input-label"
}
const _hoisted_14 = { class: "kn-list--column" }
const _hoisted_15 = { class: "p-col" }
const _hoisted_16 = { class: "kn-list-item" }
const _hoisted_17 = { class: "kn-list-item-text" }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { id: "operationInfo" }
const _hoisted_20 = { class: "p-fluid p-m-5" }
const _hoisted_21 = { class: "p-field p-d-flex" }
const _hoisted_22 = { class: "p-float-label" }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  for: "parFather",
  class: "kn-material-input-label"
}
const _hoisted_25 = { class: "p-float-label" }
const _hoisted_26 = {
  for: "filterOperation",
  class: "kn-material-input-label"
}
const _hoisted_27 = { class: "p-float-label" }
const _hoisted_28 = {
  for: "logicOperator",
  class: "kn-material-input-label"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_30 = { class: "p-d-flex p-ai-center" }
const _hoisted_31 = { class: "mode-inputs" }
const _hoisted_32 = { class: "mode-inputs" }
const _hoisted_33 = { class: "kn-material-input-label" }
const _hoisted_34 = { key: 0 }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_KnHint = _resolveComponent("KnHint")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputSwitch = _resolveComponent("InputSwitch")
  const _component_Card = _resolveComponent("Card")
  const _component_Button = _resolveComponent("Button")
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_Checkbox = _resolveComponent("Checkbox")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, null, {
      header: _withId(() => [
        _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
          start: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('managers.businessModelManager.driversDetails')), 1)
          ]),
          _: 1
        })
      ]),
      content: _withId(() => [
        (!_ctx.selectedDriver)
          ? (_openBlock(), _createBlock(_component_KnHint, {
              key: 0,
              title: 'managers.businessModelManager.drivers',
              hint: 'managers.businessModelManager.noDriverSelected',
              "data-test": "driver-hint"
            }, null, 8, ["title", "hint"]))
          : (_openBlock(), _createBlock("form", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _createVNode("span", _hoisted_3, [
                  _createVNode(_component_InputText, {
                    id: "label",
                    class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.driver.label.$invalid && _ctx.v$.driver.label.$dirty
                            }],
                    type: "text",
                    modelValue: _ctx.v$.driver.label.$model,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.driver.label.$model = $event)),
                    modelModifiers: { trim: true },
                    maxLength: "40",
                    onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.driver.label.$touch())),
                    onInput: _ctx.setChanged,
                    disabled: _ctx.readonly,
                    "data-test": "label-input"
                  }, null, 8, ["modelValue", "class", "onInput", "disabled"]),
                  _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('managers.businessModelManager.driverTitle')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.driver.label,
                  additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.businessModelManager.driverTitle')
                        }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_5, [
                _createVNode("span", null, [
                  _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('managers.businessModelManager.analyticalDriver')) + " * ", 1),
                  _createVNode(_component_Dropdown, {
                    id: "parameter",
                    class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.driver.parameter.$invalid && _ctx.v$.driver.parameter.$dirty
                            }],
                    modelValue: _ctx.v$.driver.parameter.$model,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.v$.driver.parameter.$model = $event)),
                    options: _ctx.analyticalDrivers,
                    placeholder: _ctx.$t('managers.businessModelManager.analyticalDriverPlaceholder'),
                    filter: true,
                    filterMatchMode: "contains",
                    filterFields: ['label'],
                    disabled: _ctx.readonly,
                    onBeforeShow: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.driver.parameter.$touch())),
                    onChange: _ctx.showAnalyticalDropdownConfirm
                  }, {
                    value: _withId((slotProps) => [
                      (slotProps.value)
                        ? (_openBlock(), _createBlock("div", _hoisted_7, [
                            _createVNode("span", null, _toDisplayString(slotProps.value.label), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    option: _withId((slotProps) => [
                      _createVNode("div", null, [
                        _createVNode("span", null, _toDisplayString(slotProps.option.label), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["class", "modelValue", "options", "placeholder", "disabled", "onChange"])
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.driver.parameter,
                  additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.businessModelManager.analyticalDriver')
                        }
                }, null, 8, ["vComp", "additionalTranslateParams"])
              ]),
              _createVNode("div", _hoisted_8, [
                _createVNode("span", _hoisted_9, [
                  _createVNode(_component_InputText, {
                    id: "parameterUrlName",
                    class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.driver.parameterUrlName.$invalid && _ctx.v$.driver.parameterUrlName.$dirty
                            }],
                    type: "text",
                    modelValue: _ctx.v$.driver.parameterUrlName.$model,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.driver.parameterUrlName.$model = $event)),
                    modelModifiers: { trim: true },
                    maxLength: "20",
                    disabled: _ctx.readonly,
                    onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.v$.driver.parameterUrlName.$touch())),
                    onInput: _ctx.setChanged,
                    "data-test": "parameterUrlName-input"
                  }, null, 8, ["modelValue", "class", "disabled", "onInput"]),
                  _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('managers.businessModelManager.driversUrl')) + " * ", 1)
                ]),
                _createVNode(_component_KnValidationMessages, {
                  vComp: _ctx.v$.driver.parameterUrlName,
                  additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.businessModelManager.driversUrl')
                        },
                  specificTranslateKeys: { custom_unique: 'managers.businessModelManager.driversUrlNotUnique' }
                }, null, 8, ["vComp", "additionalTranslateParams", "specificTranslateKeys"])
              ]),
              _createVNode("div", _hoisted_11, [
                _createVNode(_component_InputSwitch, {
                  id: "driver-multivalue ",
                  class: "p-mr-2",
                  modelValue: _ctx.driver.multivalue,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.driver.multivalue = $event)),
                  disabled: _ctx.readonly,
                  onChange: _ctx.setChanged
                }, null, 8, ["modelValue", "disabled", "onChange"]),
                _hoisted_12,
                _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('managers.businessModelManager.multivalue')), 1)
              ])
            ]))
      ]),
      _: 1
    }),
    (_ctx.selectedDriver)
      ? (_openBlock(), _createBlock(_component_Card, { key: 0 }, {
          header: _withId(() => [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
              start: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.businessModelManager.driverDataConditions')), 1)
              ]),
              end: _withId(() => [
                _createVNode(_component_Button, {
                  class: "kn-button p-button-text",
                  onClick: _ctx.showForm,
                  disabled: _ctx.modes.length === 0 || !_ctx.driver.id || _ctx.readonly
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('managers.businessModelManager.addCondition')), 1)
                  ]),
                  _: 1
                }, 8, ["onClick", "disabled"])
              ]),
              _: 1
            })
          ]),
          content: _withId(() => [
            _createVNode("div", _hoisted_14, [
              _createVNode("div", _hoisted_15, [
                _createVNode(_component_Listbox, {
                  class: "kn-list",
                  options: _ctx.conditions,
                  listStyle: "max-height:calc(100% - 62px)",
                  onChange: _ctx.showForm
                }, {
                  empty: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
                  ]),
                  option: _withId((slotProps) => [
                    _createVNode("div", _hoisted_16, [
                      _createVNode("div", _hoisted_17, [
                        _createVNode("span", null, _toDisplayString(slotProps.option.filterOperation + ' ' + _ctx.$t('managers.businessModelManager.value') + ' ' + slotProps.option.parFatherUrlName), 1)
                      ]),
                      _createVNode(_component_Button, {
                        icon: "far fa-trash-alt",
                        class: "p-button-link p-button-sm",
                        disabled: _ctx.readonly,
                        onClick: _withModifiers(($event: any) => (_ctx.showConditionDeleteDialog(slotProps.option)), ["stop"])
                      }, null, 8, ["disabled", "onClick"])
                    ])
                  ]),
                  _: 1
                }, 8, ["options", "onChange"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.conditionFormVisible)
      ? (_openBlock(), _createBlock("div", _hoisted_18, [
          _createVNode(_component_Dialog, {
            class: "p-fluid kn-dialog--toolbar--primary",
            style: _ctx.businessModelDriverDetailDescriptor.conditionDialog.style,
            visible: true,
            modal: true,
            header: _ctx.$t('managers.businessModelManager.driverDataConditions'),
            closable: false
          }, {
            footer: _withId(() => [
              _createVNode(_component_Button, {
                class: "kn-button kn-button--secondary",
                label: _ctx.$t('common.close'),
                onClick: _ctx.closeForm
              }, null, 8, ["label", "onClick"]),
              _createVNode(_component_Button, {
                class: "kn-button kn-button--primary",
                label: _ctx.$t('common.save'),
                disabled: _ctx.readonly,
                onClick: _ctx.handleSubmit
              }, null, 8, ["label", "disabled", "onClick"])
            ]),
            default: _withId(() => [
              _createVNode("div", _hoisted_19, [
                _createVNode("p", null, _toDisplayString(_ctx.$t('managers.businessModelManager.operationInfo', { driver: _ctx.driver.label })), 1)
              ]),
              _createVNode("form", _hoisted_20, [
                _createVNode("div", _hoisted_21, [
                  _createVNode("div", {
                    style: _ctx.businessModelDriverDetailDescriptor.input.parFather.style
                  }, [
                    _createVNode("span", _hoisted_22, [
                      _createVNode(_component_Dropdown, {
                        id: "parFather",
                        class: "kn-material-input",
                        modelValue: _ctx.condition.parFatherId,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.condition.parFatherId = $event)),
                        options: _ctx.drivers,
                        placeholder: " ",
                        optionValue: "id",
                        disabled: _ctx.readonly
                      }, {
                        value: _withId((slotProps) => [
                          (slotProps.value)
                            ? (_openBlock(), _createBlock("div", _hoisted_23, [
                                _createVNode("span", null, _toDisplayString(_ctx.getDriverProperty(slotProps.value, 'label')), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        option: _withId((slotProps) => [
                          _createVNode("div", null, [
                            _createVNode("span", null, _toDisplayString(slotProps.option.label), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "options", "disabled"]),
                      _createVNode("label", _hoisted_24, _toDisplayString(_ctx.$t('managers.businessModelManager.driverDepends')), 1)
                    ])
                  ], 4),
                  _createVNode("div", {
                    style: _ctx.businessModelDriverDetailDescriptor.input.filterOperation.style
                  }, [
                    _createVNode("span", _hoisted_25, [
                      _createVNode(_component_Dropdown, {
                        id: "filterOperation",
                        class: "kn-material-input",
                        modelValue: _ctx.condition.filterOperation,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.condition.filterOperation = $event)),
                        options: _ctx.businessModelDriverDetailDescriptor.operations,
                        optionLabel: "name",
                        optionValue: "value",
                        disabled: _ctx.readonly
                      }, null, 8, ["modelValue", "options", "disabled"]),
                      _createVNode("label", _hoisted_26, _toDisplayString(_ctx.$t('managers.businessModelManager.filterOperator')), 1)
                    ])
                  ], 4),
                  _createVNode("div", {
                    style: _ctx.businessModelDriverDetailDescriptor.input.logicOperator.style
                  }, [
                    _createVNode("span", _hoisted_27, [
                      _createVNode(_component_Dropdown, {
                        id: "logicOperator",
                        class: "kn-material-input",
                        modelValue: _ctx.condition.logicOperator,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.condition.logicOperator = $event)),
                        options: _ctx.businessModelDriverDetailDescriptor.logicOperator,
                        optionLabel: "name",
                        optionValue: "value",
                        disabled: _ctx.readonly
                      }, null, 8, ["modelValue", "options", "disabled"]),
                      _createVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('managers.businessModelManager.logicOperator')), 1)
                    ])
                  ], 4)
                ]),
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.modes, (mode) => {
                  return (_openBlock(), _createBlock("div", {
                    key: mode.useID
                  }, [
                    _hoisted_29,
                    _createVNode("p", null, _toDisplayString(_ctx.$t('managers.businessModelManager.modality') + ': ' + mode.name), 1),
                    _createVNode("div", _hoisted_30, [
                      _createVNode("div", _hoisted_31, [
                        _createVNode(_component_Checkbox, {
                          class: "p-mr-2",
                          value: mode.useID,
                          modelValue: _ctx.selectedModes,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.selectedModes = $event)),
                          disabled: _ctx.readonly
                        }, null, 8, ["value", "modelValue", "disabled"]),
                        _createVNode("label", null, _toDisplayString(_ctx.$t('managers.businessModelManager.check')), 1)
                      ]),
                      _createVNode("div", _hoisted_32, [
                        _createVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('managers.businessModelManager.lovsColumn')), 1),
                        _createVNode(_component_Dropdown, {
                          id: "parFather",
                          class: "kn-material-input",
                          modelValue: _ctx.modalities[mode.useID],
                          "onUpdate:modelValue": ($event: any) => (_ctx.modalities[mode.useID] = $event),
                          options: _ctx.getLovs(mode.idLov),
                          placeholder: _ctx.$t('managers.businessModelManager.lovsColumnSelect'),
                          disabled: _ctx.isModeActive(mode.useID) || _ctx.readonly
                        }, {
                          value: _withId((slotProps) => [
                            (slotProps.value)
                              ? (_openBlock(), _createBlock("div", _hoisted_34, [
                                  _createVNode("span", null, _toDisplayString(slotProps.value), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          option: _withId((slotProps) => [
                            _createVNode("div", null, [
                              _createVNode("span", null, _toDisplayString(slotProps.option), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["modelValue", "onUpdate:modelValue", "options", "placeholder", "disabled"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _: 1
          }, 8, ["style", "header"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Dialog, {
      header: "Error",
      visible: _ctx.displayWarning,
      "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => (_ctx.displayWarning = $event))
    }, {
      footer: _withId(() => [
        _createVNode(_component_Button, {
          label: "Ok",
          icon: "pi pi-check",
          onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.displayWarning = false))
        })
      ]),
      default: _withId(() => [
        _createVNode("p", null, _toDisplayString(_ctx.errorMessage), 1)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
})